module.exports = "/dist/img/noshi04.d18d0407.jpg";